import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  VirtualConnectionDownstreamLensesQueryVariables, VirtualConnectionDownstreamLensesQuery, LensesDisplayGridRowDataFragment, VirtualConnectionDownstreamLensesFilteredByTableQueryVariables, VirtualConnectionDownstreamLensesFilteredByTableQuery, LensSortOrder,
  VirtualConnectionDownstreamLensesFilteredByTableDocument,
  VirtualConnectionDownstreamLensesDocument
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { LensesDisplayGrid, LensesDisplayGridRowData, getRowDataForLens } from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = VirtualConnectionDownstreamLensesQueryVariables;
type QueryResults = VirtualConnectionDownstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionDownstreamLensesFilteredByTableQueryVariables;
type QueryResultsWithFilter = VirtualConnectionDownstreamLensesFilteredByTableQuery;
type QueryResultListNodeWithFilter = LensesDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  return virtualConnection ? virtualConnection.downstreamLensesConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  const virtualConnectionTables = virtualConnection && virtualConnection.tablesConnection && virtualConnection.tablesConnection.nodes;
  const table = virtualConnectionTables && virtualConnectionTables[0];
  return table ? table.downstreamLensesConnection : null;
}

export type VirtualConnectionDownstreamLensesQueryGridProps =
  GridSortProps<LensesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionDownstreamLensesQueryGrid(props: VirtualConnectionDownstreamLensesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamLensesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredLensesLineageGridMessage();

  return props.filteredTableId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamLensesFilteredByTableDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedTableId: props.filteredTableId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => <LensesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamLensesDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => <LensesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
